<template>
  <v-container fluid>
    <v-row class="ml-1">
      <global-stallholder-single-select
        @stallholder-changed="handleStallholderChange"
      />
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-cogs </v-icon>
            Devices
            <v-spacer />
            <v-btn x-small dark class="mr-2" @click="deleteAllDevices()">
              <v-icon left x-small> mdi-delete </v-icon>
              Delete ALL Devices
            </v-btn>
            <v-btn x-small dark class="mr-2" @click="exportDevices">
              <v-icon left x-small> mdi-download </v-icon>
              Export Devices
            </v-btn>
            <v-btn x-small dark @click="importDevices">
              <v-icon left x-small> mdi-plus </v-icon>
              Add Devices
            </v-btn>
            <v-dialog v-model="dialogDeleteItem" max-width="520px" dark>
              <v-card>
                <v-card-title class="text-h6 text-wrap justify-center"
                  >Are you sure you want to delete this device?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="closeDelete">Cancel</v-btn>
                  <v-btn color="red darken-1" text @click="deleteItemConfirmed"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDeleteAllItems" max-width="520px" dark>
              <v-card>
                <v-card-title class="text-h6 text-wrap justify-center"
                  >Are you sure you want to delete ALL items for this event?
                  This cannot be undone.</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="closeDelete">Cancel</v-btn>
                  <v-btn
                    color="red darken-1"
                    text
                    @click="deleteAllItemsConfirmed"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="selectedDeviceProfiles"
              sort-by="StallholderId"
              single-select
              return-object
              class="elevation-5"
            >
              <!-- <template v-slot:[`header.MerchantId`]="{ header }">
              <div class="justify-center">{{ header.text }}</div>                
            </template>
            <template v-slot:[`header.DeviceId`]="{ header }">
              <div class="justify-center x-large">{{ header.text }}</div>                
            </template>
            <template v-slot:[`header.StallId`]="{ header }">
              <div class="justify-center x-large">{{ header.text }}</div>                
            </template>
            <template v-slot:[`header.TerminalNumber`]="{ header }">
              <div class="justify-center">{{ header.text }}</div>                
            </template>
            <template v-slot:[`item.StallName`]="{ item }">
                {{ item.StallName ? item.StallName : 'No data available' }}
            </template>
            <template v-slot:[`item.TerminalNumber`]="{ item }">
                {{ item.TerminalNumber ? item.TerminalNumber : 'No data available' }}
            </template>
            <template v-slot:[`item.TerminalUserName`]="{ item }">
                {{ item.TerminalUserName ? item.TerminalUserName : 'No data available' }}
            </template>
            <template v-slot:[`item.Authorised`]="{ item }">
                {{ item.Authorised ? item.Authorised : 'No data available' }}
            </template> -->

              <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
              </template>

              <template v-slot:top>
                <!-- Empty top slot to remove toolbar gap -->
              </template>

              <template v-slot:no-data>
                <v-btn color="primary">
                  No devices available for this stallholder
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import "izitoast/dist/css/iziToast.min.css";
import iziToast from "izitoast/dist/js/iziToast.min.js";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  data: () => ({
    dialog: false,
    dialogDeleteItem: false,
    dialogDeleteAllItems: false,

    headers: [
      { text: "Stallholder Name", value: "StallholderName" },
      { text: "Stall Name", value: "StallName", align: "center" },
      { text: "Device Id", value: "DeviceId", align: "center" },
      { text: "Merchant Id", value: "MerchantId", align: "center" },
      { text: "Terminal Number", value: "TerminalNumber", align: "center" },
      { text: "User Name", value: "TerminalUserName", align: "center" },
      { text: "Authorised", value: "Authorised", align: "center" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    currentDevices: [],
    allDevices: [],
    deleteItemId: "",

    editedIndex: -1,
    editedItem: {
      StallholderId: "",
      StallId: "",
      TerminalUserId: "",
      TerminalId: "",
      DeviceId: "",
    },
    defaultItem: {
      StallholderId: "",
      StallId: "",
      TerminalUserId: "",
      TerminalId: "",
      DeviceId: "",
    },

    valid: true,
  }),

  computed: {
    ...mapState("admin", [
      "currentEvent",
      "currentStallHolders",
      "currentStallholder",
    ]),

    formTitle() {
      return this.editedIndex === -1 ? "New Device" : "Edit Device";
    },

    selectedStallHolder: {
      get() {
        return this.currentStallholder;
      },
      set(value) {
        this.setCurrentStallholder(value);
      },
    },

    selectedDeviceProfiles() {
      return this.currentDevices;
    },
  },

  mounted() {
    this.getAllDevices();
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDeleteItem(val) {
      val || this.closeDelete();
    },

    currentEvent: {
      handler(newEvent) {
        if (newEvent?.EventId) {
          this.getAllDevices();
        }
      },
      immediate: true,
    },

    currentStallholder: {
      handler(newStallholder) {
        this.filterDevicesByStallholder(newStallholder);
      },
      immediate: true,
    },

    currentStallHolders: {
      handler(newStallHolders) {
        // When stallholders are updated, refresh device filtering
        if (newStallHolders && newStallHolders.length > 0) {
          this.filterDevicesByStallholder(this.currentStallholder);
        }
      },
      deep: true,
    },
  },

  methods: {
    ...mapMutations("admin", ["setCurrentStallholder"]),
    ...mapActions("admin", ["getDevices", "postDevices", "getEventMetadata"]),

    async getAllDevices() {
      if (!this.currentEvent?.EventId) return;

      try {
        const paramObj = { EventId: this.currentEvent.EventId };
        const response = await this.getDevices(paramObj);

        // Process the response to normalize UserName field
        response.forEach((device, index, devices) => {
          if ("UserName" in device) {
            devices[index].TerminalUserName = device.UserName;
            devices[index].TerminalUserId = device.UserId;
          }
        });

        this.allDevices = response;
        this.filterDevicesByStallholder(this.currentStallholder);
      } catch (error) {
        console.error("Error fetching devices:", error);
        iziToast.warning({
          title: "Devices",
          message: "Failed to load devices!",
          position: "topRight",
        });
      }
    },

    filterDevicesByStallholder(stallholder) {
      if (!stallholder || !this.allDevices) {
        this.currentDevices = this.allDevices || [];
        return;
      }

      const filteredDevices = this.allDevices.filter((device) => {
        return (
          device.StallholderId === stallholder.StallholderId ||
          device.StallholderId === "None Selected"
        );
      });

      this.currentDevices = filteredDevices;
    },

    handleStallholderChange(stallholder) {
      if (stallholder) {
        this.setCurrentStallholder(stallholder);
      }
    },

    editItem(item) {
      this.$router.push({
        name: "Device Import",
        params: {
          id: item.DeviceId,
          deviceData: item,
          stallholderData: this.currentStallholder,
        },
      });
    },

    deleteItem(item) {
      console.log("deleteItem (item)", item);
      this.deleteItemId = item.DeviceId;
      this.dialogDeleteItem = true;
    },

    async deleteItemConfirmed() {
      try {
        if (this.deleteItemId) {
          const deletedItem = {
            Type: "Device",
            Action: "delete",
            Devices: [{ DeviceId: this.deleteItemId }],
          };

          await this.postDevices(deletedItem);

          // Refresh the admin state to get updated data from server
          if (this.currentEvent?.EventId) {
            await this.getEventMetadata(this.currentEvent.EventId);
          }

          // Refresh the device list
          await this.getAllDevices();

          iziToast.success({
            title: "Device",
            message: "Successfully deleted the device!",
            position: "topRight",
          });
        }
      } catch (error) {
        console.error("Delete device error:", error);
        iziToast.warning({
          title: "Device",
          message: "Failed to delete record!",
          position: "topRight",
        });
      }

      this.closeDelete();
    },

    deleteAllDevices: function () {
      console.log("dialogDeleteAllItems");
      this.dialogDeleteAllItems = true;
    },

    async deleteAllItemsConfirmed() {
      try {
        const deletedMetaData = {
          Type: "Device",
          Action: "deleteAll",
          EventId: this.currentEvent.EventId,
        };

        await this.postDevices(deletedMetaData);

        // Refresh the admin state to get updated data from server
        if (this.currentEvent?.EventId) {
          await this.getEventMetadata(this.currentEvent.EventId);
        }

        // Refresh the device list
        await this.getAllDevices();

        iziToast.success({
          title: "Device",
          message: "Successfully deleted all devices for the event!",
          position: "topRight",
        });
      } catch (error) {
        console.error("Delete all devices error:", error);
        iziToast.warning({
          title: "Device",
          message: "Failed to delete all devices!",
          position: "topRight",
        });
      }

      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDeleteItem = false;
      this.dialogDeleteAllItems = false;
      this.deleteItemId = "";
    },

    importDevices() {
      this.$router.push({
        name: "Device Import",
        params: {
          id: 0,
          stallholderData: this.currentStallholder,
        },
      });
    },

    exportDevices() {
      const headers = [
        "DeviceID",
        "MerchantId",
        "Authorised",
        "Stallholder",
        "Stall",
        "Terminal",
        "User",
      ];

      const data = this.currentDevices.map((device) => [
        device.DeviceId || "",
        device.MerchantId || "",
        device.Authorised || "",
        device.StallholderName || "",
        device.StallName || "",
        device.TerminalNumber || "",
        device.TerminalUserName || "",
      ]);

      const csvContent = [
        headers.join(","),
        ...data.map((row) => row.join(",")),
      ].join("\n");

      // Create filename in format: EventName-StallholderName-devices.csv
      const eventName = this.currentEvent?.EventName || "Event";
      const stallholderName = this.currentStallholder?.StallholderName || "All";
      const filename = `${eventName}-${stallholderName}-devices.csv`;

      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      iziToast.success({
        title: "Export",
        message: "Devices exported successfully!",
        position: "topRight",
      });
    },
  },
};
</script>

<style scoped>
h1 {
  color: #a09c94;
  font-family: sans-serif;
}
.v-data-table-header th {
  white-space: nowrap;
}
</style>
